// extracted by css-extract-rspack-plugin
export default {"cls1":"StatelessWorkCardsUpsellModal-styles-cls1_euc","cls2":"StatelessWorkCardsUpsellModal-styles-cls2_2zN StatelessWorkCardsUpsellModal-styles-cls1_euc"};